import { computed } from 'vue';

import { useWindowSize } from '@vueuse/core/index';

import { BREAKPOINTS } from '@/utils/constants/common';

export const useDeviceSize = () => {
  const { width, height } = useWindowSize();

  const isDesktop = computed<boolean>(() => {
    return width.value >= BREAKPOINTS.DESKTOP;
  });
  const isTablet = computed<boolean>(() => {
    return width.value < BREAKPOINTS.DESKTOP && width.value >= BREAKPOINTS.TABLET;
  });
  const isMobile = computed<boolean>(() => {
    return width.value < BREAKPOINTS.TABLET;
  });

  const isDesktopOrTablet = computed<boolean>(() => {
    return isDesktop.value || isTablet.value;
  });
  const isMobileOrTablet = computed<boolean>(() => {
    return isMobile.value || isTablet.value;
  });
  return {
    width,
    height,
    isDesktop,
    isDesktopOrTablet,
    isMobileOrTablet,
    isMobile,
    isTablet,
  };
};
